module.exports = __webpack_public_path__ + "assets/img/banner-10.bf3d9c3a.jpg";